import { render } from "./AccountsList.vue?vue&type=template&id=6b7fc0a0&ts=true"
import script from "./AccountsList.vue?vue&type=script&lang=ts"
export * from "./AccountsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItemSection});
